import { render, staticRenderFns } from "./VOverlay.vue?vue&type=template&id=1ef95407&scoped=true"
import script from "./VOverlay.vue?vue&type=script&lang=js"
export * from "./VOverlay.vue?vue&type=script&lang=js"
import style0 from "./VOverlay.vue?vue&type=style&index=0&id=1ef95407&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef95407",
  null
  
)

export default component.exports